import Snowfall from 'react-snowfall'
import SnowStorm from 'react-snowstorm';



export const myStyleDark = {
  backgroundColor: "#1f2a44",
  border: "1px solid rgba(255, 255, 255, 0.12)",
  borderRadius: "18px",
  boxShadow: "0 10px 24px rgba(0, 0, 0, 0.18)",
  backdropFilter: "blur(6px)",
};

export const myStyleLight = {
  backgroundColor: "#f6f8fb",
  border: "1px solid rgba(31, 42, 68, 0.08)",
  borderRadius: "18px",
  boxShadow: "0 8px 18px rgba(31, 42, 68, 0.10)",
  fontFamily: "Criativa Sans Regular",
}


export const BWHeader = (finalIsDarkMode, mainText, contentText) => (
  <>
    <div className="container">
      <div
        className="p-3"
        style={ finalIsDarkMode ? myStyleDark : myStyleLight }
      >
        <div className="container-fluid">
          <h1 className={ `display-5 fw-bold ${ finalIsDarkMode ? "text-white" : "text-black" }` }>
            { mainText }
          </h1>
          <br/>

          <h3 className={ `${ finalIsDarkMode ? "text-white" : "text-black" }` }>
            { contentText }
          </h3>
        </div>
      </div>
    </div>
  </>
);

export const center = (element) => {
  return (
    <div style={{ "display": "flex", "justifyContent": "center"}} >
      { element }
    </div>
  )
}

export const ConditionalSnow = (snowIsEnabled) => (
  snowIsEnabled ?
    (<>
      <SnowStorm
        excludeMobile={false}
        followMouse={false}
      />
      <Snowfall />
    </>)
    : <></>
)

export const space6 = (
  <>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
  </>
);

export const space3 = (
  <div>
    <br/>
    <br/>
    <br/>
  </div>
);


export const space18 = (
  <>
    { space6 }
    { space6 }
    { space6 }
  </>
);

